module.exports = __webpack_public_path__ + "static/media/ic-facebook.554f61d7.svg";